import React, { useState, useEffect, useRef } from "react";
import SliderComponent from "../SliderComponent";
import "../../css/EMICalculator.css";

const EMICalculator = ({ closeEmiModal }) => {
  const modalRef = useRef(null);
  const [loanAmount, setLoanAmount] = useState(3500000);
  const [tenure, setTenure] = useState(30);
  const interestRate = 6.95;
  const interestRate2 = 8.99;
  

  const formatPrice = (price) => {
    if (price >= 1_00_00_000) return `${(price / 1_00_00_000).toFixed(2)} CR`;
    if (price >= 1_00_000) return `${(price / 1_00_000).toFixed(2)} L`;
    if (price >= 1_000) return `${(price / 1_000).toFixed(2)} K`;
    return `${price}`;
  };

  const calculateEMI = (principal, years, rate1, rate2) => {
    const getEMI = (p, r, n) =>
      (p * r * Math.pow(1 + r, n)) / (Math.pow(1 + r, n) - 1);
    const emi1 = getEMI(principal, rate1 / (12 * 100), years * 12);
    const emi2 = getEMI(principal, rate2 / (12 * 100), years * 12);
    return `${formatPrice(emi1.toFixed(2))} - ${formatPrice(emi2.toFixed(2))}`;
  };
  const emi = calculateEMI(loanAmount, tenure, interestRate, interestRate2);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        closeEmiModal();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [closeEmiModal]);

  return (
    <div ref={modalRef} className="emi-modal">
      <h4 className="emi-heading">EMI Calculator</h4>
      <div style={{ padding: "0px 15px" }}>
        {/* Loan Amount Slider */}
        <SliderComponent
          label="Loan Amount"
          value={loanAmount}
          onChange={setLoanAmount}
          min={2000000}
          max={14400000}
          step={10000}
          formattedValue={`₹${formatPrice(loanAmount)}`}
        />

        {/* Tenure Slider */}
        <SliderComponent
          label="Tenure"
          value={tenure}
          onChange={setTenure}
          min={1}
          max={30}
          step={1}
          formattedValue={`${tenure} Years`}
        />

        {/* EMI Display */}
        <div>
          <h6 className="emi-h6">
            Calculated EMI: <strong>₹{emi}/month</strong>
          </h6>
          <p className="emi-note">
            Based on {tenure} years tenure and {interestRate}% interest rate.
          </p>
        </div>
      </div>
    </div>
  );
};

export default EMICalculator;
